import { createTheme } from "@mui/material";

const theme = createTheme({
  typography: {
    fontFamily: "Proxima Nova, sans-serif",
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "0px",
          fontFamily: "Proxima Nova, sans-serif",
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "1px solid #1b2838",
          },
        },
        input: {
          padding: "16.5px 14px",
          color: "#1b2838",
        },
      },
    },
  },
});

export default theme;
